// https://vuex.vuejs.org/en/state.html

export default {
    token: localStorage.getItem("user-token") || "",
    user: localStorage.getItem("user-username") || "",
    name: localStorage.getItem("user-name") || "",
    phoneNumber: localStorage.getItem("user-phoneNumber") || "",
    status: "",
};
